import $ from 'jquery'
import Vue from 'vue';
import VueSanitize from "vue-sanitize";
import { cca_config } from '@/plugins/cca-config'



let defaultOptions = {
    allowedTags: ['img', 'png', 'jpeg', 'jpg'],
    allowedAttributes: {
      'img': [ 'src', 'alt' ]
    }
};
Vue.use(VueSanitize, defaultOptions);

function default_info_clinique() {
    return {
        type_entete: 'infos', logo: '', type_centre: 'Clinique', nom: '',
        pays: '', code_pays: '', fuseau_horaire: '', url_connexion: '', ville: '', adresse: '', specialites: '',
        code_autorisation: '', entete: '', pied_page: '', has_info: true
    }
}

export default {
    name: 'info-clinique',
    components: {},
    props: [],
    data() {
        return {
            info_clinique: default_info_clinique(),
            is_loading: true,
            load_error: '',
            save_loading: false,
            save_error: '',
            pays_modifie: false,
            default_country: '',
            default_city: '',
            selected_pays: null,
            selected_timezone: null,

            img_url: '',
            preview_media: { logo: '', entete: '', pied_page: '' },
            media_errors: { logo: false, entete: false, pied_page: false },
            preview_open: false,

            can_print: false
        }
    },
    computed: {
        config_info_clinique() {
            return this.$store.getters["config_info_clinique"];
        },
        countries() {
            return cca_config.COUNTRIES || []
        },
        timezones() {
            return (this.selected_pays && this.selected_pays.timezones) || []
        },
        types_structure_disponibles() {
            const types = [
                'Clinique', 'CMS', 'Cabinet', 'Polyclinique', 'Hôpital',
                'Centre hospitalier', 'Centre de santé', 'Dispensaire',
                'Maternité', 'Laboratoire d’analyses', 'Centre d’imagerie',
                'Centre de diagnostic', 'Poste de santé', 'Autre'
            ]
            const actuel = this.info_clinique.type_centre
            if (actuel && !types.includes(actuel)) types.push(actuel)
            return types
        },
    },

    created() {
        // The global mixin assigns the cached Vuex object here (sometimes []).
        // Keep an independent, complete form before either mounted hook runs.
        this.info_clinique = default_info_clinique()
    },
    mounted() {
        this.getInfoClinique()
        
    },
    methods: {
        previewFile(el) {
            var file = document.querySelector('input[name='+el+']').files[0];
            var reader = new FileReader();
            
            if (file) {
                reader.readAsDataURL(file);
                if (el == 'logo') {
                    this.info_clinique.logo = file
                } else if (el == 'entete') {
                    this.info_clinique.entete = file
                } else if (el == 'pied_page') {
                    this.info_clinique.pied_page = file
                }
            }

            reader.addEventListener("load", () => {
                if (Object.prototype.hasOwnProperty.call(this.preview_media, el)) {
                    this.media_errors[el] = false
                    this.preview_media[el] = reader.result
                }
            }, false);
        },

        mediaSrc(el) {
            if (this.preview_media[el]) return this.preview_media[el]
            return this.info_clinique[el] ? this.assets_path + '/config/' + this.info_clinique[el] : ''
        },

        initFields() {
            const saved_info = this.config_info_clinique
            const source = saved_info && typeof saved_info === 'object' && !Array.isArray(saved_info)
                ? saved_info : {}
            const form_info = default_info_clinique()
            Object.keys(form_info).forEach((key) => {
                if (source[key] !== null && source[key] !== undefined && source[key] !== '') {
                    form_info[key] = source[key]
                }
            })
            form_info.ville = form_info.ville || this.default_city
            form_info.pays = form_info.pays || this.default_country
            this.info_clinique = form_info

            this.selected_pays = this.countries.find(c => c.code === this.info_clinique.code_pays)
                || this.countries.find(c => c.nom === this.info_clinique.pays)
                || null

            this.selected_timezone = this.timezones.find(t => t.value === this.info_clinique.fuseau_horaire)
                || this.timezones[0]
                || null
            if (!this.info_clinique.fuseau_horaire && this.selected_timezone) {
                this.info_clinique.fuseau_horaire = this.selected_timezone.value
            }
        },

        onPaysChange(option) {
            this.info_clinique.pays = option ? option.nom : ''
            this.info_clinique.code_pays = option ? option.code : ''

            // Fixe le fuseau horaire par défaut du pays choisi (le premier de la liste)
            this.selected_timezone = this.timezones[0] || null
            this.info_clinique.fuseau_horaire = this.selected_timezone ? this.selected_timezone.value : ''

            // Devise principale (et, pour les deux Congo, devise secondaire USD) déduites du pays : proposition
            // affichée dans Devise ; devise et coupures de billetage ne s'appliquent qu'à « Enregistrer ».
            this.$store.dispatch('applyCountryCurrencyDefaults', option)
            const pays_enregistre = (this.config_info_clinique || {}).code_pays || ''
            this.pays_modifie = !!(option && option.code && option.code !== pays_enregistre)
        },

        onTimezoneChange(option) {
            this.info_clinique.fuseau_horaire = option ? option.value : ''
        },

        fillMedia() {
            this.media_errors = { logo: false, entete: false, pied_page: false }
        },

        setLocal() {
            var city = ''
            var country = ''
            $.ajax({
                url: 'https://ip-api.com/json',
                type: 'GET',
                success: function(json) {
                    country = json.country
                    city = json.city
                    
                }, error: function() {
                    // 
                }
            }).then(() => {
                this.default_city = city
                this.default_country = country
            })
            
        },

        async getInfoClinique() {
            this.is_loading = true
            this.load_error = ''
            this.preview_media = { logo: '', entete: '', pied_page: '' }
            this.media_errors = { logo: false, entete: false, pied_page: false }
            try {
                await this.$store.dispatch('getConfigInfoClinique', 'info_clinique')
                this.initFields()
            } catch (error) {
                this.load_error = "Impossible de charger les informations de l’établissement. Vérifiez la connexion puis réessayez."
            } finally {
                this.is_loading = false
            }
            if (!this.load_error) {
                await this.$nextTick()
                this.fillMedia()
            }
        },

        async saveConfig() {
            if (this.is_loading || this.load_error) return
            this.save_error = ''
            this.info_clinique.has_info = true
            // Never switch old documents to an empty image header.
            if (this.info_clinique.entete) this.info_clinique.type_entete = 'image'

            this.save_loading = true

            let form_data = new FormData();
            for (let key in this.info_clinique) {
                form_data.append(key, (this.info_clinique[key] == null)?'':this.info_clinique[key])
            }
            form_data.append('data_type', 'info_clinique')

            try {
                const response = await this.$store.dispatch('saveConfigInfoClinique', form_data)
                if (response > 0) {
                    if (this.pays_modifie) await this.appliquerDevisePays()
                    await this.getInfoClinique()
                } else {
                    this.save_error = "L’enregistrement n’a pas abouti. Réessayez."
                }
            } catch (error) {
                // Un refus explicite du serveur (ex. URL de connexion invalide) est affiché tel quel.
                const refus = error && error.response && error.response.status === 422 && error.response.data && error.response.data.message
                this.save_error = refus || "Impossible d’enregistrer les informations ou les images. Vérifiez les fichiers puis réessayez."
            } finally {
                this.save_loading = false
            }
        },

        // Nouveau pays enregistré : le serveur a remplacé les coupures de billetage ; la devise proposée est enregistrée.
        async appliquerDevisePays() {
            try {
                await this.$store.dispatch('appliquerDevisePays')
                this.pays_modifie = false
                this.successToast('Devise et coupures de billetage du pays appliquées.')
            } catch (error) {
                this.save_error = "Identité enregistrée, mais la devise du pays n’a pas pu l’être : enregistrez-la dans la section Devise."
            }
        },

        previewEntete() {
            // A live DOM preview keeps selected FileReader images and persisted
            // images visible; converting cross-origin assets to canvas/PDF hid them.
            this.preview_open = true
        },

        imageReceived() {
            let canvas = document.createElement("canvas");
            let context = canvas.getContext("2d");
          
            canvas.width = this.img_url.width;
            canvas.height = this.img_url.height;
          
            context.drawImage(this.img_url, 0, 0);
            // imageBox.appendChild(canvas);
          
            try {
              localStorage.setItem("saved-image-example", canvas.toDataURL("image/png"));
            }
            catch(err) {
              console.log("Error: " + err);
            }
        }
    }
}
